import { faRotate } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Rotate icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/rotate?f=classic&s=solid
 */
export function RotateIcon(props: CustomIconProps) {
  return <Icon icon={faRotate} {...props} />;
}
